<template>
    <div class="notification-list-widget">

        <div class="card">
            <h3 class="card-header d-flex justify-content-between">
                New Notifications: {{ unreadNotifications.length }}{{ (unreadNotifications.length == max_notifications) ? '+' : ''}}
                <router-link class="link-light mt-2 mt-sm-0" :to="'/notifications'">View All Notifications
                    <b-icon-bell/>
                </router-link>
            </h3>
            <spinner-until :condition="!loading">
                <div class="card-body overflow-auto" style="max-height: 300px"
                     v-if="unreadNotifications && unreadNotifications.length">
                    <table class="table table-striped">
                        <tr>
                            <th>Message</th>
                            <th>Actions</th>
                        </tr>
                        <tr v-for="(n, i) in unreadNotifications" :key="i">
                            <td v-html="truncate(n.message)"/>
                            <td style="white-space:nowrap;">
                                <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                        @click="viewItem(i)">
                                    <b-icon-eye/>
                                </button>
                                <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                        @click="setNotificationAsRead(n)">
                                    <b-icon-envelope-open/>
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
                <div v-else class="card-body text-center" style="color: gray">
                    No Notifications
                </div>
            </spinner-until>
            <notification-view-modal v-if="unreadNotifications"
                                     :notification="unreadNotifications[viewNotification]"
                                     modalId="viewNotificationModal"/>
        </div>
    </div>
</template>

<script>
import * as _ from 'lodash'

export default {
    name: 'NotificationListWidget',
    data () {
        return {
            max_notifications: 50,
            notifications: null,
            viewNotification: 0,
            loading: true
        }
    },
    async mounted () {
        const filters = {
            currentNotificationsForId: {
                field: 'currentNotificationsForId',
                type: 'hidden',
                value: this.$user.userId()
            }
        }
        this.notifications = await this.$api.getItems(this, 'notification', filters, { perPage: this.max_notifications, sort: '-created' }, ['equipment'])
        this.loading = false
    },
    methods: {
        viewItem (item) {
            this.$bvModal.show('viewNotificationModal')
            this.viewNotification = item
        },
        truncate (str, length = 128, end = '...') {
            return str.length > length ? str.substring(0, length - end.length) + end : str
        },
        setNotificationAsRead (notification) {
            notification.status = 'READ'
            this.$api.updateItem(this, 'notification', notification)
        }
    },
    computed: {
        sortedNotifications () {
            return _.orderBy(this.notifications, 'created', 'desc')
        },
        unreadNotifications () {
            return _.filter(this.sortedNotifications, n => n.status === 'UNREAD')
        },
    }
}
</script>
